import React, { useState } from "react";

import { localizedText } from "shared/lib/localizedMap";
import { Button, Select } from "shared/ui";

import { PeriodPickerModal } from "features/Statistics/components/PeriodPickerModal";
import { useStatisticsContext } from "features/Statistics/context";

import { MenuSelectCell, Toolbar } from "./styles";

export const StatsToolbar = () => {
    const { menuOptions, menuId, setMenuId, periodLabel, locale } = useStatisticsContext();

    const [isPeriodOpen, setIsPeriodOpen] = useState<boolean>(false);

    return (
        <Toolbar>
            <MenuSelectCell>
                <Select
                    title="Меню"
                    value={menuId === null ? "" : menuId}
                    options={menuOptions.map((option) => ({
                        value: option.id,
                        label: localizedText(option.name, locale),
                    }))}
                    onChange={(value) => setMenuId(Number(value))}
                />
            </MenuSelectCell>
            <Button variant="outlined" color="neutral" onClick={() => setIsPeriodOpen(true)}>
                {periodLabel}
            </Button>

            {/* Модалку рендерим только открытой: закрытая она держала бы свой стейт вкладки. */}
            {isPeriodOpen && (
                <PeriodPickerModal open onClose={() => setIsPeriodOpen(false)} />
            )}
        </Toolbar>
    );
};
